import { BehaviorSubject } from 'rxjs'

import { NotamFeature, NotamFeatureCollection } from '@/domain/models/Notam'

interface HighlightedNotamsStateProps {
  collection: NotamFeatureCollection
  highlightedIds: Set<string | number>
}

const INITIAL_STATE: HighlightedNotamsStateProps = {
  collection: {
    type: 'FeatureCollection',
    features: []
  },
  highlightedIds: new Set()
}

export const HighlightedNotamsState = new BehaviorSubject<HighlightedNotamsStateProps>(INITIAL_STATE)

export const HighlightedNotamsStateMutator = {
  addNotam: (notam: NotamFeature) => {
    const current = HighlightedNotamsState.getValue()
    if (current.highlightedIds.has(notam.id)) {
      return
    }

    const newIds = new Set(current.highlightedIds)
    newIds.add(notam.id)

    HighlightedNotamsState.next({
      collection: {
        type: 'FeatureCollection',
        features: [...current.collection.features, notam]
      },
      highlightedIds: newIds
    })
  },

  removeNotam: (notamId: string | number) => {
    const current = HighlightedNotamsState.getValue()
    const newIds = new Set(current.highlightedIds)
    newIds.delete(notamId)

    HighlightedNotamsState.next({
      collection: {
        type: 'FeatureCollection',
        features: current.collection.features.filter((f) => f.id !== notamId)
      },
      highlightedIds: newIds
    })
  },

  toggleNotam: (notam: NotamFeature) => {
    const current = HighlightedNotamsState.getValue()
    if (current.highlightedIds.has(notam.id)) {
      HighlightedNotamsStateMutator.removeNotam(notam.id)
    } else {
      HighlightedNotamsStateMutator.addNotam(notam)
    }
  },

  isHighlighted: (notamId: string | number): boolean => {
    return HighlightedNotamsState.getValue().highlightedIds.has(notamId)
  },

  clear: () => {
    HighlightedNotamsState.next({
      collection: {
        type: 'FeatureCollection',
        features: []
      },
      highlightedIds: new Set()
    })
  }
}
